import React from 'react';
import { observer } from 'mobx-react';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { useTheme } from '@mui/material/styles';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { CashbackPopup } from '@gamiphy/loyalty-station-desktop/components/cashback/cashbackPopup';
import { GlobalStyles } from '@mui/material';
import { FramePortal } from '@gamiphy/loyalty/components/framePortal';
import { getThemeFontStyleSheets } from '@gamiphy/loyalty/theme';

const CashbackPopupFrame = () => {
  const theme = useTheme();

  if (!AppStore.initialized) return null;

  return (
    <div
      style={{
        display: 'block',
        zIndex: 2147483648,
        position: 'relative',
        transition: `all 1s ${theme.transitions.easing.easeOut}`,
        height: '100%',
      }}
    >
      <FramePortal
        sx={{ width: '100%', height: '100%', position: 'relative' }}
        stylesheets={getThemeFontStyleSheets(ThemeStore.theme)}
        theme={theme}
        dir={AppStore.dir}
      >
        <GlobalStyles styles={{ html: { fontSize: '10px' } }} />
        <CashbackPopup />
      </FramePortal>
    </div>
  );
};

export default observer(CashbackPopupFrame);
